import _slicedToArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useControlledState } from "@react-stately/utils";
/**
 * Provides state management for a search field.
 */

export function useSearchFieldState(props) {
  var _useControlledState = useControlledState($a9d4cb04630987986dd69a33031$var$toString(props.value), $a9d4cb04630987986dd69a33031$var$toString(props.defaultValue) || '', props.onChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      value = _useControlledState2[0],
      setValue = _useControlledState2[1];

  return {
    value: value,
    setValue: setValue
  };
}

function $a9d4cb04630987986dd69a33031$var$toString(val) {
  if (val == null) {
    return;
  }

  return val.toString();
}